// src/components/CatylexSearch/CatylexNotSupported.tsx

import * as React from "react";
import { CatylexSuggestion } from "../../interfaces/catylexSearchTypes";
import { catylexColors } from "./catylexSearchStyles";

interface CatylexNotSupportedProps {
  reason: string;
  suggestions: CatylexSuggestion[];
  availableConcepts: string[];
}

const CatylexNotSupported: React.FC<CatylexNotSupportedProps> = ({
  reason,
  suggestions,
  availableConcepts,
}) => {
  const containerStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  };

  const reasonBoxStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    padding: "10px 12px",
    borderRadius: "6px",
    backgroundColor: catylexColors.warningBg,
    fontSize: "12px",
    lineHeight: "1.5",
    color: catylexColors.warningColor,
  };

  const sectionLabelStyle: React.CSSProperties = {
    fontSize: "11px",
    fontWeight: 600,
    color: catylexColors.foreground,
    margin: 0,
    marginBottom: "6px",
  };

  const chipContainerStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: "wrap" as const,
    gap: "6px",
  };

  const suggestionChipStyle: React.CSSProperties = {
    fontSize: "11px",
    padding: "4px 10px",
    borderRadius: "12px",
    backgroundColor: catylexColors.chipBg,
    color: catylexColors.primary,
  };

  const conceptChipStyle: React.CSSProperties = {
    fontSize: "10px",
    padding: "3px 8px",
    borderRadius: "10px",
    backgroundColor: catylexColors.conceptBg,
    color: catylexColors.mutedForeground,
  };

  const WarningIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke={catylexColors.warningColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, marginTop: "1px" }}
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );

  return (
    <div style={containerStyle}>
      <div style={reasonBoxStyle}>
        <WarningIcon />
        <span>{reason}</span>
      </div>

      {suggestions.length > 0 && (
        <div>
          <p style={sectionLabelStyle}>Try instead:</p>
          <div style={chipContainerStyle}>
            {suggestions.map((suggestion, idx) => (
              <span key={idx} style={suggestionChipStyle}>
                {typeof suggestion === "string" ? suggestion : suggestion.suggestion_text}
              </span>
            ))}
          </div>
        </div>
      )}

      {availableConcepts.length > 0 && (
        <div>
          <p style={sectionLabelStyle}>Available search concepts:</p>
          <div style={chipContainerStyle}>
            {availableConcepts.map((concept, idx) => (
              <span key={idx} style={conceptChipStyle}>
                {concept}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CatylexNotSupported;
